import { Component } from '@angular/core';

@Component({
    selector: 'app-runners',
    templateUrl: './runners.component.html',
    styleUrl: './runners.component.css',
    standalone: false
})
export class RunnersComponent {

}
